import React, { useCallback } from 'react';
import { CustomActionCell, Action } from '../../../../components';
import { useDispatch } from "react-redux";
import { CheckIcon } from '../../../../components/icon/solid';
import {
  createStyles,
  makeStyles,
  Theme
} from "@material-ui/core";
import { saveUserPermissionsRequestDirty } from '../../../../store/modules/user-permissions/actions';
import { UserPermissions, ListsItem } from '../../../../types/items';

interface Props {
  original: UserPermissions,
  list: ListsItem[] | null,
  field: 'user_association_id' | 'user_permission_id',
  title: string;
}

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  icon: {
    color: palette.buttonSingle.color,
    verticalAlign: 'middle',
    fontSize: '1rem'
  },
}), { name: 'TabTeam' });

const UserPermissionAction = ({ original, list, field, title }: Props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const onClickHandler =  useCallback((id:number) => {
    return () => {
      const newData = {...original, [field]: id};
      dispatch(saveUserPermissionsRequestDirty(newData));
    }
  }, [dispatch, original, field]);

  return (
    <CustomActionCell title={title}>
      {list?.map(((item, key) =>
          (<Action
            title={item.value}
            key={key}
            iconPosition='end'
            onClick={onClickHandler(item.key)}
            {...(item.key === original[field] && {
              icon: <CheckIcon className={classes.icon}/>,
              disabled: true,
            }) }
          />)
      ))}
    </CustomActionCell>
  )
};

export default UserPermissionAction;
